import { SelectedMenu } from 'rangeConfig/@types';
import replaceSelectedTopPanel from 'rangeConfig/besta/behaviors/replaceSelectedTopPanel';
import {
  matchTopPanelDepth,
  matchTopPanelWidth
} from 'rangeConfig/besta/filters/selectedMenuProductFilters';
import deleteProduct from 'rangeConfig/shared/behaviors/deleteProduct';

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListChangeTopPanel',
  behaviors: {
    productDeleted: [deleteProduct]
  },
  content: [
    {
      id: 'top-panels-selected-menu-top-panels',
      title: 'storageone.productListTopPanelsTitle',
      cardsTitle: 'name',
      cardsSubtitle: 'designText, communicatedSizeText',
      behaviors: {
        productClicked: [replaceSelectedTopPanel],
        productDropped: [replaceSelectedTopPanel]
      },
      productFilters: [matchTopPanelWidth, matchTopPanelDepth]
    }
  ]
};

export default selectedMenu;
